<div class="page-content" [ngClass]="getClass()">
	
	<div class="main-content"  *ngIf="(currentTaxonomyPage$ | push) as page" >
		<h1>{{page.entityLabel}}</h1>
		<span class="content" [innerHtml]="normalizeBody(page)"></span>
	</div>


</div>

<app-page-bottom></app-page-bottom>